import React, { CSSProperties, ReactNode } from "react";
import { useTheme } from "styled-components";
import { SpacingStyle } from "core/styles/paddingMarginStyle";
import { CircleStyled } from "./_circleStyled";

export type CircleProps = {
  size?: number;
  color?: string;
  onClick?: React.MouseEventHandler;
  children?: ReactNode;
  borderColor?: string;
  style?: CSSProperties;
} & SpacingStyle;

function Circle(props: CircleProps) {
  const theme = useTheme();
  const { size, color = theme?.colors?.primary.default, children, ...rest } = props;

  return (
    <CircleStyled size={size} color={color} {...rest}>
      {children}
    </CircleStyled>
  );
}

Circle.defaultProps = {
  size: 6,
  color: "",
};

export default Circle;
